<template>
    <div class="infinite">
        <template v-for="(list, index) in teasers">




            <div class="row without_sliders no-gutters">
                <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4" :teaser="list[0]" :position="getPosition(index, 0)"></teaser4>
                <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="list[1]" :position="getPosition(index, 1)"></teaser4>
                <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="list[2]" :position="getPosition(index, 2)"></teaser4>
            </div>

            <div class="row without_sliders no-gutters" v-if="isTable()">

                <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="list[3]" :position="getPosition(index, 3)"></teaser4>
                <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="list[4]" :position="getPosition(index, 4)"></teaser4>
                <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4"  :teaser="list[5]" :position="getPosition(index, 5)"></teaser4>
            </div>

<!--infinite-scroll-distance-->

        </template>
        <infinite-loading @infinite="infiniteHandler($event)" direction="bottom" infinite-scroll-disabled="busy" distance="610"  ref="infiniteLoading" >
            <span slot="no-more"></span>
            <span slot="no-results">{{Helper.t('not_found')}}</span>
        </infinite-loading>

    </div>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    import teaser from '@/components/teaser.vue'
    import teaser2 from '@/components/teaser2.vue'
    import teaser4 from '@/components/teaser4.vue'


    export default {
        name: "infinite",
        props:['offset','typeContent'],
        components: {
            InfiniteLoading,
            teaser,
            teaser2,
            teaser4,
        },
        data() {
            return {
                teasers:[],
                start:0,
            };
        },

        mounted() {
            // window.fac();
            this.start = this.offset + 1;
        },
        methods:{
            infiniteHandler($state) {

                let amount = (this.isTable()) ? 6 : 3;
				let skipCount = null;
//                 console.log("this.Helper.query.sid9", this.Helper.query.sid9);
                if (this.Helper.query.sid9 === 'preview') {
                    skipCount = 7;
                }
                
                let qu = {quality:1};
                
                if (this.type_content !== undefined) {
                     qu = Object.assign(qu, {type_content:type_content});
                } 
               
                this.Helper.getTeasers(this, amount, this.offset, 0, 0, qu, skipCount)
                    .onSuccess((response) => {


                        this.offset += response.data.length;
                        // window.fac();

                        if (response.data.length) {
                            this.teasers.push(response.data);
                            $state.loaded();
                        } else {
                            $state.complete();
                        }

                    })
                    .onFail((error)=>{
                        console.log(error);
                        $state.error();
                    })

            },
            getPosition(index, n)
            {
                return this.start + ((this.isTable()) ? index * 5 + n : index * 2 + n);
            }

        }
    }
</script>

<style scoped>

</style>